export const AUTOMATIC_TEAMS_EDIT_SETTINGS = {
  1: "Only admins",
  2: "Only admins and team leaders",
  3: "No one",
} as { [key: number]: string };
